import { render, staticRenderFns } from "./BoardsView.vue?vue&type=template&id=14f4e75e&scoped=true"
import script from "./BoardsView.vue?vue&type=script&lang=js"
export * from "./BoardsView.vue?vue&type=script&lang=js"
import style0 from "./BoardsView.vue?vue&type=style&index=0&id=14f4e75e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f4e75e",
  null
  
)

export default component.exports